import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { 
       Exhibitor,
       fetchExhibitor, 
       deleteExhibitor, 
       getBrandingFiles,
       unassignExhibitorFromEvent,
       resetExhibitorPassword,
} from '../../services/api';
import { getAvatarUrl } from '../../services/api';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import { useAuth } from '../../contexts/AuthContext';
import Menu from '../../components/menu/Menu';
import CustomTypography from '../../components/customTypography/CustomTypography';
import CustomButton from '../../components/customButton/CustomButton';
import { ReactComponent as  CatalogEntryIcon} from '../../assets/catalog_entryIcon.svg';
import { ReactComponent as  DocumentsIcon} from '../../assets/documentsIcon.svg';
import { ReactComponent as  InvitationsIcon} from '../../assets/invitationsIcon.svg';
import { ReactComponent as  EventScheduleIcon} from '../../assets/event_scheduleIcon.svg';
import { ReactComponent as  BadgesIcon} from '../../assets/BadgesIcon.svg';
import { ReactComponent as  TradeAwardcIcon} from '../../assets/trade_fair_awardsIcon.svg';



import {
  Avatar,
  Box,
  Container,
  //Paper,
  CircularProgress,
  Alert,
  Link,
  Breadcrumbs,
  // TabContext,
  // TabList,
  Tab,
} from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
import { ReactComponent as LogoutIcon } from '../../assets/log-out.svg';
import styles from './ExhibitorCardPageShort.module.scss';
import ExhibitorsPageIcon from '../../assets/mask-group-6@2x.png';
import { ReactComponent as BackIcon } from '../../assets/back.svg';
import { ReactComponent as WastebasketIcon } from '../../assets/wastebasket.svg';
import { ReactComponent as EditIcon } from '../../assets/editIcon.svg';
import { ReactComponent as KeyIcon } from '../../assets/keyIcon.svg';
import { ReactComponent as AddIcon } from '../../assets/addIcon.svg';
import Applause from '../../assets/applause.png';
import SingleEventCard from '../../components/singleEventCard/SingleEventCard';
import AddEventToExhibitorModal from '../../components/addEventToExhibitorModal/AddEventToExhibitorModal';
import { fetchExhibitorAssignment } from '../../services/api';
import type { ExhibitorEvent } from '../../services/api';
import ExhibitorWithEvent from '../../components/exhibitorWithEvent/ExhibitorWithEvent';
import ExhibitorDatabaseDocuments from '../../components/exhibitorDatabaseDocuments/ExhibitorDatabaseDocuments';
import ExhibitoiIdentifiers from '../../components/exhibitoiIdentifiers/ExhibitoiIdentifiers';
import ExhibitorInvitations from '../../components/exhibitorInvitations/ExhibitorInvitations';
import ExhibitorScheduleOfEventsAtTheStand from '../../components/exhibitorScheduleOfEventsAtTheStand/ExhibitorScheduleOfEventsAtTheStand';
import ExhibitorTradeFairAwards from '../../components/exhibitorTradeFairAwards/ExhibitorTradeFairAwards';
import EditExhibitorModal from '../../components/editExhibitorModal/EditExhibitorModal';
import ConfirmationDialog from '../../components/confirmationDialog/ConfirmationDialog';




const ExhibitorCardPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [exhibitor, setExhibitor] = useState<Exhibitor | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();
  const {token, user, logout } = useAuth();
  const buildAvatarUrl = useCallback((userId?: number | null): string | undefined => {
    if (!userId || !token) return undefined;
    return getAvatarUrl(userId, token);
  }, [token]);
  const [value, setValue] = React.useState(0);
  const [selectedEvent,setSelectedEvent]=useState<number | null>(null)
  const [selectedParticipation,setSelectedParticipation]=useState<number | null>(null)
  const [hasLogo, setHasLogo] = useState<boolean>(false);
  const [isEventAddToExhibitor, setIsEventAddToExhibitorn] = useState<boolean>(false);
  const [isAdditionalStandOpen, setIsAdditionalStandOpen] = useState<boolean>(false);
  const [isEditEventOpen, setIsEditEventOpen] = useState<boolean>(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  
  const [openConfirm, setOpenConfirm] = useState(false); //To confirm delete Exhibitor
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const loadExhibitor = useCallback(async (): Promise<void> => {
    if (!token || !id) {
      setError('Brak autoryzacji lub nieprawidłowe ID wystawcy.');
      logout();
      navigate('/login');
      return;
    }

    try {
      setLoading(true);
      const fetchedExhibitor = await fetchExhibitor(parseInt(id), token);
      setExhibitor(fetchedExhibitor);
      setError('');
    } catch (err: any) {
      setError(err.message || 'Nie udało się pobrać danych wystawcy');
      if (err.message.includes('401')) {
        logout();
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }, [token, id, logout, navigate]);

  useEffect(() => {
    loadExhibitor();
  }, [loadExhibitor]);

  // Load branding info for selected event to detect if exhibitor uploaded any logo-like file
  useEffect(() => {
    const checkLogo = async () => {
      if (!token || !exhibitor || !selectedEvent) {
        setHasLogo(false);
        return;
      }
      try {
        const resp = await getBrandingFiles(exhibitor.id, selectedEvent, token);
        const files = resp.files || {};
        const logoTypes = ['biale_logo_identyfikator', 'banner_wystawcy_800', 'banner_wystawcy_1200'];
        const hasAnyLogo = logoTypes.some((t) => Boolean(files[t]));
        setHasLogo(hasAnyLogo);
      } catch (_e) {
        setHasLogo(false);
      }
    };
    void checkLogo();
  }, [token, exhibitor, selectedEvent]);

  const handleBack = () => {
    navigate('/wystawcy');
  };

  const handleDeleteExhibitor = async () => {
    if (!token || !exhibitor) return;
    if (!window.confirm(`Czy na pewno chcesz usunąć wystawcę "${exhibitor.companyName}"?`)) return;
    try {
      await deleteExhibitor(exhibitor.id, token);
      navigate('/wystawcy');
    } catch (err: any) {
      setError(err.message || 'Błąd podczas usuwania wystawcy');
    }
  };

  const handleResetExhibitorPassword = async () => {
    if (!token || !exhibitor) return;
    try {
      const res = await resetExhibitorPassword(exhibitor.id, token);
      alert(res?.message || 'Nowe hasło zostało wysłane do wystawcy.');
    } catch (err: any) {
      const msg = err?.message || 'Błąd podczas resetowania hasła wystawcy';
      setError(msg);
      if (String(msg).includes('401')) {
        logout();
        navigate('/login');
      }
    }
  };

  const handleConfirmDelete = () => {
    handleDeleteExhibitor();
    setOpenConfirm(false);
  };




  const handleModalClose = useCallback((): void => {
      setIsEventAddToExhibitorn(false);
      setIsAdditionalStandOpen(false);
      try { (window as any).__prefillExhibitorAssign = null; } catch {}
  }, []);
  // Dane edytowanego stoiska nie mogą przetrwać zamknięcia okna edycji – inaczej
  // „dodaj wydarzenie" otworzyłoby się w trybie edycji i nadpisało to stoisko.
  const handleEditEventClose = useCallback((): void => {
      setIsEditEventOpen(false);
      try { (window as any).__prefillExhibitorAssign = null; } catch {}
  }, []);
  const handleEventToExhibitiorAdd = useCallback((): void => {
      setIsEventAddToExhibitorn(false);
      setIsAdditionalStandOpen(false);
      // Reload exhibitor to reflect newly assigned event
      loadExhibitor();
  }, [loadExhibitor]);


  //
  // Wybór dotyczy konkretnego stoiska – przy dwóch stoiskach na tym samym wydarzeniu
  // bez tego zakładki poniżej pokazywałyby zawsze dane pierwszego z nich.
  const handleSelectEvent = (eventId: number, participationId?: number) => {
    if (!exhibitor) return;
    setSelectedEvent(eventId);
    setSelectedParticipation(participationId ?? null);
  };
  

  const handleDeleteEventFromExhibitor = async (eventId: number, exhibitorId: number, participationId?: number) => {
    if (!token) return;
    try {
      await unassignExhibitorFromEvent(exhibitorId, eventId, token, participationId ?? null);
      await loadExhibitor();
    } catch (err: any) {
      setError(err.message || 'Błąd podczas odłączania wydarzenia od wystawcy');
    }
  };

  useEffect(() => {
    const handler = (e: any) => {
      const d = e?.detail || {};
      if (typeof d?.id === 'number') {
        // Preload current assignment details into the add/edit modal fields by temporarily overriding its defaults
        // We open the modal; the modal itself fetches event list. We'll additionally fetch assignment here to prefill.
        (async () => {
          try {
            if (exhibitor && token) {
              const assign = await fetchExhibitorAssignment(exhibitor.id, d.id, token, d.participationId ?? null);
              // Store into a temp global to be read by modal via window (simple bridge without refactor)
              // `participationId` z kafelka wskazuje, które stoisko edytujemy.
              (window as any).__prefillExhibitorAssign = assign?.data
                ? { ...assign.data, exhibitionId: d.id, participationId: d.participationId }
                : { exhibitionId: d.id, participationId: d.participationId };
            }
          } catch {}
          setIsEditEventOpen(true);
        })();
      }
    };
    window.addEventListener('open-edit-event-modal', handler as any);
    return () => window.removeEventListener('open-edit-event-modal', handler as any);
  }, [exhibitor, token]);


    const getEventImage = (index: number): number => {
      return index % 2 === 0 ? 1: 2;
    };

  // Kilka stoisk na jednym wydarzeniu trzeba rozróżnić na liście kafelków.
  const buildStandLabel = (event: ExhibitorEvent): string | undefined => {
    const sameEvent = (exhibitor?.events || []).filter(e => e.id === event.id);
    if (sameEvent.length < 2) return undefined;
    const opis = [event.hallName, event.standNumber].filter(Boolean).join(' / ');
    if (opis) return `Stoisko: ${opis}`;
    const kolejnosc = sameEvent.findIndex(e => e.participationId === event.participationId) + 1;
    return `Stoisko ${kolejnosc} z ${sameEvent.length}`;
  };

  const getEventReadiness = (eventId: number): number => {
    return eventId % 3 === 0 ? 21 : 65;
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  
  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ padding: '24px 0px' }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const renderSelectedEvent = () => {
    if (selectedEvent !== null && exhibitor?.events) {
      return exhibitor.events
        .filter(event => event.id === selectedEvent)
        .filter(event => selectedParticipation === null || event.participationId === selectedParticipation)
        .map((event, index) => (
          <Box key={event.participationId ?? event.id} className={styles.eventBusinessCard}>
            <CustomTypography className={styles.selestedTitleWrapper}>Wydarzenie:</CustomTypography>
            <SingleEventCard 
              id={event.id}
              exhibitorId={exhibitor.id}
              iconId={getEventImage(index)}
              event_readiness={getEventReadiness(event.id)}
              title={event.name}
              start_date={event.start_date}
              end_date={event.end_date}
              participationId={event.participationId}
              standLabel={buildStandLabel(event)}
              showEdit
              preferTileLogo={false}
              handleSelectEvent={handleSelectEvent}
              handleDeleteEventFromExhibitor={handleDeleteEventFromExhibitor}
              showDelete={false}
              showSelect={false}
            />
          </Box>
        ));
    }
    return <CustomTypography>Nie wybrano wydarzenia</CustomTypography>;
  };
 
 return (
    <>
    <Box className={styles.pageContainer}>
      <Box>
        <Box className={styles.pageNavigationContainer}>
          <Box className={styles.pageHeader}>
            <Menu /> 
            <CustomButton 
              disableRipple
              textColor='#060606ff'
              fontSize="0.75em;"
              className={styles.logOutButton}
              onClick={handleLogout}
              icon={<LogoutIcon style={{ color: "#6F6F6F", height:"1.25em"}}/>} 
              iconPosition="top" 
              withBorder={false}
              width="auto"
              height="auto"
              sx={{ 
                  backgroundColor:'transparent',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#060606ff',
                  },
                }}
            >
              Wyloguj
            </CustomButton>
            <Box className={styles.welcomeMessage}>
              <Box 
                className={styles.backContainer}
                onClick={handleBack}
              >
                <BackIcon className={styles.backIcon} />
                <CustomTypography className={styles.backText}> wstecz </CustomTypography>
              </Box>
              <Box className={styles.logedUserInfo}>
                {(() => {
                  const src = buildAvatarUrl(user?.id);
                  return (
                    <Avatar
                      {...(src ? { src } : {})}
                      alt={user?.firstName || 'User'}
                      className={styles.avatar}
                      onClick={() => console.log("")}
                    />
                  );
                })()}
                <Box> 
                  <CustomTypography className={styles.welcomeMessageTitle}> Dzień dobry, {user?.firstName || 'Użytkowniku'} 
                  <img
                    src={Applause}
                    alt='Applause'
                    className={styles.applausepng}
                  />
                  </CustomTypography>
                  <CustomTypography className={styles.welcomeMessageText}>Sprawdź co możesz dzisiaj zrobić!</CustomTypography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Container  
          maxWidth={false}  
          sx={{ maxWidth: '90%' }}
          className={styles.contentWrapper}
        > 
            <Box className={styles.tableHeader}>
                <Box className={styles.titleTableContainer}>
                    <Box className={styles.pageTitleContainer}>
                        <img src={ExhibitorsPageIcon} alt="Wystawcy" className={styles.pageIcon} />
                        <CustomTypography className={styles.pageTitle}>Wystawcy</CustomTypography>              
                    </Box>
                    <Box className={styles.breadcrumbs}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link onClick={() => navigate('/dashboard')}>Home</Link>
                            <Link onClick={() => navigate('/wystawcy')}>Baza wystawców</Link>
                            <CustomTypography className={styles.linkEnd}>
                                {exhibitor?.companyName}

                            </CustomTypography>
                        </Breadcrumbs>
                    </Box>
                </Box>
                <Box className={styles.exhibitionData}>
                   <Box className={styles.exhibitorCard}>
                        <Box className={styles.exhibitorCardData}>
                           <Box className={styles.box}>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel} >Nazwa Wystawcy:</CustomTypography>
                                    <CustomTypography  className={styles.infoGroupValue_cn}>{exhibitor?.companyName}</CustomTypography>
                                </Box>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel} >NIP:</CustomTypography>
                                    <CustomTypography  className={styles.infoGroupLabel}> {exhibitor?.nip}</CustomTypography>
                                </Box>
                            </Box>
                            <Box className={styles.box}>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel}>Dane kontaktowe:</CustomTypography>
                                    <CustomTypography  className={styles.infoGroupValue}>{exhibitor?.contactPerson}</CustomTypography>
                                </Box>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel}> Adres:  </CustomTypography>
                                    <CustomTypography  className={styles.infoGroupLabel}> {exhibitor?.address}, {exhibitor?.postalCode} {exhibitor?.city}</CustomTypography>
                                </Box>
                            </Box>
                            <Box className={styles.box}>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel}>e-mail:</CustomTypography>
                                    <CustomTypography  className={styles.infoGroupValue}>{exhibitor?.email}</CustomTypography>
                                </Box>
                                <Box className={styles.infoGroup}>
                                    <CustomTypography  className={styles.infoGroupLabel}>tel.:</CustomTypography>
                                    <CustomTypography  className={styles.infoGroupValue}>{exhibitor?.phone}</CustomTypography>
                                </Box>
                            </Box>
                        </Box>
                        <Box className={styles.exhibitorCardAction}>
                            <Box 
                            className={styles.actionButton}
                             onClick={() => setOpenConfirm(true)}
                            >
                                <WastebasketIcon 
                                className={styles.wastebasketIcon} 
                                />
                                <CustomTypography className={styles.wastebasketText}> usuń </CustomTypography>
                            </Box>
                            <Box 
                              className={styles.actionButton}
                              onClick={() => setIsEditOpen(true)}
                            >
                              <EditIcon className={styles.wastebasketIcon} />
                              <CustomTypography className={styles.wastebasketText}> edycja </CustomTypography>
                            </Box>
                        </Box> 
                   </Box>
                </Box>
                {selectedEvent === null
                ?<>
                  <Box className={styles.infoRow}>
                    <Box className={styles.row}>
                        <Box className={styles.sectionTitle}>
                         {(exhibitor?.events && exhibitor.events.length > 0 )
                            ? <CustomTypography  className={styles.titleForAllPlanedExhibitions}>  Zaplanowane wydarzenie wystawcy:</CustomTypography>
                            : <CustomTypography className={styles.noEvents}>Brak zaplanowanych wydarzeń wystawcy</CustomTypography>}  
                        </Box>
                        <Box className={styles.sectionAction}>
                            <Box className={styles.actionButton} onClick={handleResetExhibitorPassword}>
                                    <KeyIcon className={styles.keyIcon} />
                                    <CustomTypography className={styles.wastebasketText}> wyślij nowe hasło </CustomTypography>
                            </Box>
                            <Box 
                              className={styles.actionButton} 
                              onClick={() => setIsEventAddToExhibitorn(true)}
                            >
                                <AddIcon className={styles.addIcon} />
                                <CustomTypography className={styles.wastebasketText}> + dodaj wydarzenie </CustomTypography>
                            </Box>
                            {exhibitor?.events && exhibitor.events.length > 0 ? (
                              <Box
                                className={styles.actionButton}
                                onClick={() => setIsAdditionalStandOpen(true)}
                                title="Firma kupiła kolejne stoisko na wydarzeniu, w którym już bierze udział"
                              >
                                <AddIcon className={styles.addIcon} />
                                <CustomTypography className={styles.wastebasketText}> + dodaj kolejne stoisko </CustomTypography>
                              </Box>
                            ) : null}
                        </Box>
                    </Box>
                  </Box>
                  
                  <Box className={styles.allExhibitions}>
                      {exhibitor?.events && exhibitor.events.length > 0 
                      && ( exhibitor.events.map((event,index) =>              
                          <SingleEventCard 
                            id={event.id}
                            exhibitorId={exhibitor.id}
                            iconId={getEventImage(index)}
                            event_readiness={getEventReadiness(event.id)}
                            key={event.participationId ?? event.id}
                            participationId={event.participationId}
                            standLabel={buildStandLabel(event)}
                            title={event.name}
                            start_date={event.start_date}
                            end_date={event.end_date}
                            preferTileLogo={false}
                            handleSelectEvent={handleSelectEvent}
                            handleDeleteEventFromExhibitor={handleDeleteEventFromExhibitor}
                            showEdit
                            /> 
                          ))}

                  </Box>
              </>
              :null}


            {selectedEvent === null
             ? <></>
             : <Box className={styles.singleEventInfo} sx={{flexGrow: 1,width:'100%',bgcolor: 'background.paper'}}>
                <Box>
                  <Tabs
                          value={value}
                          onChange={handleChange}
                          variant="scrollable"
                          scrollButtons="auto"
                          allowScrollButtonsMobile
                          aria-label="visible arrows tabs example"
                          slotProps={{
                            scrollButtons: {
                              disableRipple: true,
                            },
                          }}
                          sx={{
                            minHeight: 48,
                            '& .MuiTabs-indicator': {
                              display: 'none',
                            },
                            '& .MuiTabs-scroller': {
                              overflowX: 'auto !important',
                            },
                            '& .MuiTab-root': {
                              flex: 1,
                              minWidth: 190,
                              marginRight: 1.5,
                              textTransform: 'none',
                              fontSize: 15,
                              fontWeight: 400,
                              color: 'black',
                              minHeight: '48px',
                              whiteSpace: 'nowrap',
                              transition: 'color 0.2s, border-bottom 0.2s, background-color 0.2s',
                              borderBottom: '2px solid transparent',
                              '&:hover': {
                                color: '#FC8A06',
                              },
                              '&.Mui-selected': {
                                color: '#FC8A06',
                              },



                              '@media (max-width:600px)': {
                                '& .tab-label-text': {
                                  display: 'none !important',
                                },
                                  flex: 'unset',
                                  //minWidth: '4em',
                                    minWidth: 60, // ✅ szerokość minimalna na mobile
                                  paddingLeft: 0,
                                  paddingRight: 0,
                                  justifyContent: 'center', // wycentrowanie ikony
                                
                                '&:hover': {
                                  borderBottom: '2px solid #FC8A06',
                                  color: '#FC8A06',
                                  backgroundColor: 'transparent',
                                },
                                '&.Mui-selected': {
                                  borderBottom: '2px solid #FC8A06',
                                  color: '#FC8A06',
                                },
                              },

                            },
                            '& .MuiTab-root:last-child': {
                              marginRight: 0,
                            },
                            '& .MuiTab-wrapper': {
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: '8px',
                              whiteSpace: 'nowrap',
                              flexShrink: 0, 
                              '& svg': {
                                flexShrink: 0, 
                              },
                              '@media (max-width:600px)': {
                                '& .tab-label-text': {
                                  display: 'none !important',
                                },
                              },
                            },
                            '& .tab-label-text': {
                              display: 'inline-block',
                              borderBottom: '2px solid transparent',
                              paddingBottom: '1px',
                              transition: 'border-bottom 0.2s, color 0.2s',
                            },
                            '& .Mui-selected .tab-label-text': {
                              borderBottom: '2px solid #FC8A06',
                              color: '#FC8A06',
                              whiteSpace: 'nowrap',
                            // Media query ukrywające label w mobile
                              '@media (max-width:600px)': {
                                '& .tab-label-text': {
                                  display: 'none !important',
                                },
                                '& .Mui-selected .tab-label-text': {
                                  borderBottom: '2px solid transparent', // usuwamy podkreślenie z tekstu w mobile
                                },
                              }},
                            [`& .${tabsClasses.scrollButtons}`]: {
                              '&.Mui-disabled': {
                                opacity: 0.3,
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.04)',
                              },
                            },
                          }}
                        >
                          <Tab
                            disableRipple
                            icon={<CatalogEntryIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Wpisz do katalogu</span>}
                            {...a11yProps(0)}
                          />
                          <Tab
                            disableRipple
                            icon={<DocumentsIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Dokumenty</span>}
                            {...a11yProps(1)}
                          />
                          <Tab
                            disableRipple
                            //disabled
                            //sx={{ display: 'none' }}
                            icon={<InvitationsIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Zaproszenia</span>}
                            {...a11yProps(2)}
                          />
                          <Tab
                            disableRipple
                            icon={<EventScheduleIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Plan wydarzeń</span>}
                            {...a11yProps(3)}
                          />
                          <Tab
                            disableRipple
                            icon={<BadgesIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Identyfikatory</span>}
                            {...a11yProps(4)}
                          />
                          <Tab
                            disableRipple
                            icon={<TradeAwardcIcon />}
                            iconPosition="start"
                            label={<span className="tab-label-text">Nagrody Targowe</span>}
                            {...a11yProps(5)}
                            sx={{ display: 'none' }}
                          />
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ? <ExhibitorWithEvent exhibitorId={exhibitor.id} exhibitor={exhibitor} hasLogo={hasLogo} exhibitionId={selectedEvent ?? undefined} participationId={selectedParticipation ?? undefined} /> : null}</Box>
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ? <ExhibitorDatabaseDocuments exhibitorId={exhibitor.id} exhibitionId={selectedEvent}/> : null}</Box>
                  </Box>                  
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ? <ExhibitorInvitations exhibitorId={exhibitor.id} exhibitor={exhibitor} exhibitionId={selectedEvent ?? undefined} /> : null}</Box>
                  </Box>                    
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ? (
                      <ExhibitorScheduleOfEventsAtTheStand
                        exhibitorId={exhibitor.id}
                        exhibitor={exhibitor}
                        exhibitionId={selectedEvent ?? undefined}
                      />
                    ) : null}</Box>
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ?<ExhibitoiIdentifiers exhibitorId={exhibitor.id} exhibitor={exhibitor} exhibitionId={selectedEvent ?? undefined} /> : null}</Box>
                  </Box>  
                </CustomTabPanel>
                <CustomTabPanel value={value} index={5}>
                  <Box className={styles.tabPaperContainer}>
                    <Box className={styles.leftContainer}>{renderSelectedEvent()}</Box>
                    <Box className={styles.rightContainer}>{exhibitor ?<ExhibitorTradeFairAwards exhibitorId={exhibitor.id} exhibitionId={selectedEvent ?? undefined} /> : null}</Box>
                  </Box>  
                </CustomTabPanel>
                    </Box>}

            </Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>} 

            {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                <CircularProgress />
            </Box>
            ) : <></>} 
         </Container>
     </Box>
     
      {exhibitor && <AddEventToExhibitorModal
        isOpen={isEventAddToExhibitor}
        onClose={handleModalClose}
        onEventToExhibitiorAdd={handleEventToExhibitiorAdd}
        token={token || ''}
        exhibitorId={exhibitor?.id}
        companyName={exhibitor?.companyName}
        exhibitorEvents={exhibitor.events ?? []}
        />}

      {exhibitor && isAdditionalStandOpen && (
        <AddEventToExhibitorModal
          isOpen={isAdditionalStandOpen}
          onClose={handleModalClose}
          onEventToExhibitiorAdd={handleEventToExhibitiorAdd}
          token={token || ''}
          exhibitorId={exhibitor.id}
          companyName={exhibitor.companyName}
          exhibitorEvents={exhibitor.events ?? []}
          mode="additionalStand"
        />
      )}

      {exhibitor && isEditEventOpen && (
        <AddEventToExhibitorModal
          isOpen={isEditEventOpen}
          onClose={handleEditEventClose}
          onEventToExhibitiorAdd={() => { handleEditEventClose(); loadExhibitor(); }}
          token={token || ''}
          exhibitorId={exhibitor.id}
          companyName={exhibitor.companyName}
          exhibitorEvents={exhibitor.events ?? []}
        />
      )}

      {exhibitor && (
        <EditExhibitorModal
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          onExhibitorUpdated={loadExhibitor}
          token={token || ''}
          exhibitor={exhibitor}
        />
      )}

      <Box className={styles.footer}>
        <CustomTypography className={styles.cc}>
          Kontakt • Polityka prywatności • www.warsawexpo.eu
        </CustomTypography>
      </Box>
    </Box>
    <Box className={styles.filtr}>
      <Box className={styles.filtrGray}/>
      <Box className={styles.filtrBlue}/>
    </Box>

    <ConfirmationDialog
      open={openConfirm}
      onClose={() => setOpenConfirm(false)}
      onConfirm={handleConfirmDelete}
      title="Usuwanie wystawcy"
      description="Chcesz usunąć wystawcę?"
    />
    </>
  );
};

export default ExhibitorCardPage;
